export default __webpack_public_path__ + "static/media/placeholder_private01-jp-web.07b7a4b4.png";